/**
 * Async Types
 * @type {{PENDING: string, SUCCESS: string, ERROR: string}}
 */
export const helperTypes = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  WATCHER: "WATCHER",
};



// WEBPACK FOOTER //
// ./src/modules/NTICore/constants/helperTypes.js